/* eslint-disable react/prop-types */
import React from "react";
import DatePicker from "react-flatpickr";
import { Vietnamese } from "flatpickr/dist/l10n/vn";
import { Box, Typography } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftInput from "components/SoftInput";
import SwitchBox from "components/SwitchBox";
import SoftTypography from "components/SoftTypography";
import { useEffect } from "react";

const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
};

const ModalContent = (Props) => {
  const { list, setList, pickAll, setPickAll } = Props;
  const [taxPeriod, setTaxPeriod] = React.useState("month"); // | arise
  const [taxType, setTaxType] = React.useState("firstTime"); // | additional
  console.log(Props);

  const handleChangeSwitch = (name, checked) => {
    console.log(name, "name");
    console.log(checked);
    setList((prev) =>
      prev.map((item) => {
        if (item.name === name) {
          return { ...item, checked };
        }
        return item;
      })
    );
  };
  useEffect(() => {
    if (pickAll) {
      setList((prev) =>
        prev.map((item) => {
          return { ...item, checked: true };
        })
      );
    }
  }, [pickAll]);

  return (
    <>
      <Box
        sx={{
          p: 1,
          border: "1px solid black",
          borderRadius: 1,
        }}
      >
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Chọn kỳ tính thuế
        </Typography>
        <SoftBox display="flex" flexDirection="column" my={1}>
          <SoftTypography component="label" variant="caption" fontWeight="bold" mb={0.5}>
            Tỉnh khác nơi đóng trụ sở chính
          </SoftTypography>
          <select style={selectStyle}>
            <option value="1">Cần thơ</option>
            <option value="2">An giang</option>
            <option value="3">TP Hồ chí minh</option>
          </select>
        </SoftBox>
        <SoftBox display="flex" flexDirection="column" my={1}>
          <SoftTypography component="label" variant="caption" fontWeight="bold" mb={0.5}>
            CQT cấp cục
          </SoftTypography>
          <select style={selectStyle}>
            <option value="1">HCM-Cục thuế Thành phố Hồ Chí Minh</option>
            <option value="2">HCM-Cục thuế Thành phố Hồ Chí Minh</option>
          </select>
        </SoftBox>
        <SoftBox display="flex" flexDirection="column" my={1}>
          <SoftTypography component="label" variant="caption" fontWeight="bold" mb={0.5}>
            CQT nơi nộp
          </SoftTypography>
          <select style={selectStyle}>
            <option value="1">Cục thuế Thành phố Hồ Chí Minh</option>
            <option value="2">Cục thuế Thành phố Hồ Chí Minh</option>
          </select>
        </SoftBox>

        <Box
          sx={{
            display: "flex",
            gap: 1,
          }}
        >
          <Box>
            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Tháng
              </SoftTypography>
            </SoftBox>
            <SoftInput name={taxPeriod} type="number" defaultValue={10} />
          </Box>
          <Box>
            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Năm
              </SoftTypography>
            </SoftBox>
            <SoftInput name="year" type="number" />
          </Box>
        </Box>

        <SwitchBox
          checked={taxType === "firstTime"}
          onChange={(e) => {
            if (taxType === "firstTime") return;
            if (e.target.checked) setTaxType("firstTime");
          }}
          sx={{ mt: 2 }}
          label="Tờ khai lần đầu"
        />
        <SwitchBox
          checked={taxType === "additional"}
          onChange={(e) => {
            if (taxType === "additional") return;
            if (e.target.checked) setTaxType("additional");
          }}
          label="Tờ khai bổ sung"
        />
        {taxType === "additional" && (
          <Box
            sx={{
              display: "flex",
              gap: 1,
            }}
          >
            <Box>
              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Lần
                </SoftTypography>
              </SoftBox>
              <SoftInput name="numberTime" type="number" defaultValue={1} />
            </Box>
            <Box>
              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Ngày lập KHBS
                </SoftTypography>
              </SoftBox>
              <DatePicker
                options={{
                  locale: Vietnamese,
                  time_24hr: true,
                  dateFormat: "d-m-Y",
                }}
                render={({ defaultValue }, ref) => (
                  <SoftInput defaultValue={defaultValue} inputRef={ref} />
                )}
              />
            </Box>
          </Box>
        )}
      </Box>
      {taxPeriod === "month" && (
        <Box
          sx={{
            p: 1,
            border: "1px solid black",
            borderRadius: 1,
            mt: 1,
          }}
        >
          <SwitchBox
            checked={pickAll}
            onChange={(e) => setPickAll(e.target.checked)}
            label="Chọn phụ lục kê khai"
          />
          <Box
            sx={{
              mt: 1,
              p: 1,
              maxHeight: 200,
              overflow: "auto",
              borderRadius: 1,
              border: "1px solid black",
            }}
          >
            {list.map((item, index) => {
              return (
                <SwitchBox
                  name={item.name}
                  checked={pickAll ? pickAll : item.checked}
                  onChange={(e) => handleChangeSwitch(item.name, e.target.checked)}
                  key={index}
                  label={item.name}
                />
              );
            })}
          </Box>
        </Box>
      )}
    </>
  );
};

export default ModalContent;
